import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized-access',
  templateUrl: './unauthorized-access.component.html',
  styleUrls: ['./unauthorized-access.component.scss']
})
export class UnauthorizedAccessComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit(): void {
  }

  gotoHomePage() {
    this._router.navigate(['welcome']);
  }
}
